<template>
    <div :class="classes">
        <template v-if="isPublished">
            <Tag
                v-if="isPublishedToDoubleClick"
                color="success"
                type="border"
                @click="showPlatformPreview(PLATFORM.DOUBLECLICK)"
            >
                {{ PlatformLabel[PLATFORM.DOUBLECLICK] }}
            </Tag>
            <Tag v-if="isPublishedToOpenDC" color="success" type="border" @click="showPlatformPreview(PLATFORM.OPENDC)">
                {{ OMSTextLabel }}
            </Tag>
        </template>
        <template v-else>
            <Tag class="library-deliverable-table-published-status-cell__tag--disabled" color="default" type="border">
                Not Published
            </Tag>
        </template>
    </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { PLATFORM } from "hoxton-shared/enums/exports";

import { PlatformLabel } from "@/enums/platforms";

export default defineComponent({
    props: {
        isPublishedToDoubleClick: {
            type: Boolean
        },
        isPublishedToOpenDC: {
            type: Boolean
        },
        openDCStatus: {
            type: String
        }
    },
    emits: ["showPlatformPreview"],
    data() {
        return {
            PLATFORM,
            PlatformLabel
        };
    },
    computed: {
        classes() {
            const classes = ["library-deliverable-table-published-status-cell"];
            const platforms = [this.isPublishedToDoubleClick, this.isPublishedToOpenDC];

            const singleTag = platforms.filter(v => v).length < 2;

            if (singleTag) {
                classes.push("library-deliverable-table-published-status-cell--full-width-tags");
            }

            return classes;
        },

        isPublished() {
            return this.isPublishedToDoubleClick || this.isPublishedToOpenDC;
        },

        OMSTextLabel() {
            if (this.openDCStatus === "SENT") {
                return `Sent to ${PlatformLabel[PLATFORM.OPENDC]}`;
            }

            if (this.openDCStatus === "RENDERED") {
                return `Rendered for ${PlatformLabel[PLATFORM.OPENDC]}`;
            }

            return PlatformLabel[PLATFORM.OPENDC];
        }
    },

    methods: {
        showPlatformPreview(platform: (typeof PLATFORM)[keyof typeof PLATFORM]) {
            this.$emit("showPlatformPreview", platform);
        }
    }
});
</script>

<style lang="scss">
@use "@style/variables" as *;

.library-deliverable-table-published-status-cell {
    overflow: hidden;

    .ivu-tag {
        cursor: pointer;
    }
}

.library-deliverable-table-published-status-cell .ivu-tag:last-child {
    margin-right: 0;
}

.library-deliverable-table-published-status-cell--full-width-tags {
    .ivu-tag {
        text-align: center;
        width: 100%;
    }
}

.library-deliverable-table-published-status-cell__tag--disabled {
    color: $grey5;
    opacity: 0.9;
    pointer-events: none;

    .ivu-tag-text {
        color: $grey5;
    }
}
</style>
